// extracted by mini-css-extract-plugin
export default {"container":"style_container__VZpSw","content":"style_content__OA9-I","top_section":"style_top_section__13VdT"};